const setAppStatus = (state, appStatus) => {
  state.approvalValue = appStatus;
};
export default {
  setAppStatus
};
